import './KunstRocaille.css';
import kunstImg from '../../assets/images/kunst_rocaille.jpg';

function KunstRocaille() {
  return (
    <section className="kunst-rocaille">
      <img src={kunstImg} alt="Kunst – Rocaille" className="kunst-rocaille__img" />
    </section>
  );
}

export default KunstRocaille;
